import type { AttachmentDto } from '@ledokol/contracts'
import { api } from './client'

export async function uploadAttachment(taskId: string, file: File): Promise<AttachmentDto> {
  const form = new FormData()
  form.append('file', file)
  const r = await api.post<AttachmentDto>(`/tasks/${taskId}/attachments`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return r.data
}

// Скачивание через blob: нужен Bearer-заголовок, прямой <a href> не подойдёт
export async function downloadAttachment(taskId: string, att: { id: string; file_name: string }) {
  const r = await api.get<Blob>(`/tasks/${taskId}/attachments/${att.id}/download`, {
    responseType: 'blob',
  })
  const url = URL.createObjectURL(r.data)
  const a = document.createElement('a')
  a.href = url
  a.download = att.file_name
  a.click()
  URL.revokeObjectURL(url)
}

export async function deleteAttachment(taskId: string, attachmentId: string): Promise<void> {
  await api.delete(`/tasks/${taskId}/attachments/${attachmentId}`)
}
